import { noop } from "lodash";
import type { MouseEvent } from "react";

import { t } from "@/i18n-js/instance";

export interface ParamsShape {
  [key: string]: string | number | boolean | undefined;
}

export interface ShowProfileArg {
  agentId: number;
  params: ParamsShape;
}

export type ShowAgentProfileDrawer = (arg: ShowProfileArg) => Promise<unknown>;

export interface GetProfileLinkArgs {
  agentId: number;
  name?: string;
  params: ParamsShape;
  shouldOpenInNewTab?: boolean;
  showAgentProfileDrawer: ShowAgentProfileDrawer;
}

export interface AgentProfileLinkProps {
  ["aria-label"]: string;
  href: string;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
  rel?: string;
  target?: string;
}

export const getAgentProfileLinkProps = ({
  name,
  params,
  agentId,
  shouldOpenInNewTab = false,
  showAgentProfileDrawer,
}: GetProfileLinkArgs): AgentProfileLinkProps => {
  const user = name ? name : t("view_user_profile_name");
  const ariaLabel = t("view_user_profile", { user });

  if (!agentId) {
    return {
      onClick: noop,
      href: "#",
      ["aria-label"]: "",
    };
  }

  if (shouldOpenInNewTab) {
    return {
      onClick: noop,
      href: "#",
      ["aria-label"]: "",
    };
  }

  return {
    onClick: event => {
      event.preventDefault();
      void showAgentProfileDrawer({
        agentId,
        params,
      });
    },
    href: "#",
    ["aria-label"]: ariaLabel,
  };
};
